import { cn } from '@/lib/cn';

/** Shown only in the user's own UI — never to other people (SPEC_V2 §3). */
export function PlusBadge({ className, size = 'sm' }: { className?: string; size?: 'sm' | 'md' }) {
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center rounded-full bg-yellow font-semibold text-night',
        size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs',
        className,
      )}
      data-testid="plus-badge"
    >
      Plus
    </span>
  );
}
